import { Box, Typography } from '@mui/material';
import { useAppSelector } from 'hooks';
import GenericApplicationCard from 'portfolio3/features/pdf/components/cards/GenericApplicationCard';
import { ApplicationMappedData } from 'portfolio3/features/proforientation/model/selectors/applications';
import { activeFormatSelector } from 'selectors/drawers';

type ApplicationExcursionsProps = {
  data: ApplicationMappedData[];
};

const ApplicationExcursions = ({ data }: ApplicationExcursionsProps) => {
  const format = useAppSelector(activeFormatSelector);

  return (
    <Box className="application-excursions">
      <Typography variant="Headings/H5">Экскурсии к работодателю</Typography>
      <Box marginTop="16px" className="application-excursions__content">
        <Box display="grid" gridTemplateColumns={format === 'horizontal' ? '1fr 1fr' : '1fr'} gap="16px">
          {data.map((entity) => {
            return (
              <GenericApplicationCard
                key={entity.eventId}
                date={entity.formattedDate}
                industry={entity.industry}
                name={entity.name}
                place={entity.place}
                statusApplicationCode={entity.statusApplication}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default ApplicationExcursions;
